import React from "react";
import { Box } from "@mui/system";

const UnreadMessagesStrip = ({
  unreadMesageCount,
  onClickJumpToPresent,
  isMobile = false,
}) => {
  return (
    <>
      {unreadMesageCount && !isMobile ? (
        <Box
          sx={{
            width: "100%",
            height: "34px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
            padding: "1px 0px 1px 0px ",
            opacity: 1,
            zIndex: 1,
            minWidth: "500px !important",
          }}
          onClick={() => {
            // viewUnseenMessages();
          }}
        >
          <Box
            style={{
              width: "100%",
              color: "#000",
              fontWeight: "400",
              fontSize: "16px",
              lineHeight: "15px",
              height: "32px",
              justifyContent: "center",
              alignItems: "center",
              display: "flex",
              zIndex: 1100,
              flexDirection: "row",
            }}
          >
            <Box
              sx={{
                height: "1px",
                background: "rgb(225, 64, 132)",
                flex: 3,
                margin: "0px 15px 0px 30px",
                display: "flex",
              }}
            ></Box>
            <Box
              sx={{
                color: "rgb(225, 64, 132)",
              }}
            >
              You have {unreadMesageCount > 100 ? "100+" : unreadMesageCount}{" "}
              unread messages
            </Box>
            <Box
              sx={{
                flex: 5,
                margin: "0px 30px 0px 0px",
                flexDirection: "row",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  height: "1px",
                  background: "rgb(225, 64, 132)",
                  flex: 2,
                  margin: "0px 15px 0px 15px",
                  display: "flex",
                }}
              ></Box>
              <span
                style={{
                  color: "rgb(225, 64, 132)",
                  marginRight: "10px",
                  fontSize: "14px",
                }}
              >
                Jump to present
              </span>

              <Box
                sx={{ cursor: "pointer" }}
                onClick={() => {
                  onClickJumpToPresent();
                }}
              >
                <img
                  src="/images/community/downArrow.png"
                  style={{
                    width: "20px",
                    height: "20px",
                    color: "rgb(225, 64, 132)",
                    borderRadius: "15px",
                    border: "1px solid",
                    opacity: 0.8,
                  }}
                  alt="community downArrow"
                />
              </Box>
              <Box
                sx={{
                  height: "1px",
                  background: "rgb(225, 64, 132)",
                  flex: 1,
                  margin: "0px 0px 0px 15px",
                }}
              ></Box>
            </Box>
          </Box>
        </Box>
      ) : (
        <></>
      )}
      {unreadMesageCount && isMobile ? (
        <Box
          sx={{
            width: "100%",
            height: "34px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
            padding: "1px 0px 1px 0px ",
            opacity: 1,
            zIndex: 1,
          }}
          onClick={() => {
            // viewUnseenMessages();
          }}
        >
          <Box
            style={{
              width: "100%",
              color: "#000",
              fontWeight: "400",
              fontSize: "16px",
              lineHeight: "15px",
              height: "32px",
              justifyContent: "center",
              alignItems: "center",
              display: "flex",
              zIndex: 1100,
              flexDirection: "row",
            }}
          >
            <span
              style={{
                height: "1px",
                background: "rgb(225, 64, 132)",
                margin: "0px 10px 0px 0px",
                width: "30px",
              }}
            ></span>
            <Box sx={{ color: "rgb(225, 64, 132)" }}>
              You have {unreadMesageCount > 100 ? "100+" : unreadMesageCount}{" "}
              unread messages
            </Box>

            <span
              style={{
                height: "1px",
                background: "rgb(225, 64, 132)",
                margin: "0px 5px 0px 10px",
                width: "30px",
              }}
            ></span>
            <Box
              sx={{ cursor: "pointer" }}
              onClick={() => {
                onClickJumpToPresent();
              }}
            >
              <img
                src="/images/community/downArrow.png"
                style={{
                  width: "20px",
                  height: "20px",
                  borderRadius: "15px",
                  border: "1px solid",
                  color: "rgb(225, 64, 132)",
                  opacity: 0.8,
                }}
                alt="community downArrow"
              />
            </Box>
          </Box>
        </Box>
      ) : (
        <></>
      )}
    </>
  );
};

export default UnreadMessagesStrip;
